import { create } from 'zustand';

export interface ConfettiBadge {
  name: string;
  description: string;
  icon: string;
}

interface ConfettiStore {
  /** Whether the full-screen celebration is currently showing */
  isActive: boolean;
  /** The badge being celebrated (null = generic confetti) */
  badge: ConfettiBadge | null;
  /** Trigger a full-screen confetti celebration with an earned badge */
  celebrate: (badge: ConfettiBadge) => void;
  /** Dismiss the celebration overlay */
  dismiss: () => void;
}

export const useConfettiStore = create<ConfettiStore>((set) => ({
  isActive: false,
  badge: null,

  celebrate: (badge) => {
    set({ isActive: true, badge });
    // Auto-dismiss after 4 seconds
    setTimeout(() => {
      set({ isActive: false, badge: null });
    }, 4000);
  },

  dismiss: () => set({ isActive: false, badge: null }),
}));
